var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.status_chart},[_c('div',{class:_vm.$style.status_chart_wrapper},[_c('radar-chart',{attrs:{"chart-data":_vm.radarData,"options":_vm.radarOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }